import React from 'react';
import Input from '../atoms/Input';
import SearchIcon from '../atoms/SearchIcon';

/**
 * Search bar molecule — Input + search icon.
 */
export default function SearchBar({
  value,
  onChange,
  onSearch,
  placeholder = 'Search',
  className = '',
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className={`ca-search ${className}`.trim()}>
      <Input
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        icon={<SearchIcon />}
        aria-label={placeholder}
      />
    </div>
  );
}
